/* eslint-disable no-param-reassign */
export const isElementHighlight = (el: HTMLElement | null): boolean =>
  el
    ? el.nodeType === 1 &&
      el.nodeName === "SPAN" &&
      typeof el.dataset?.highlightActive === "string"
    : false;

export const getHighlightSpanInParents = (
  el: HTMLElement | null,
): HTMLElement | null => {
  while (el) {
    if (el.id.includes("froala-editor")) {
      return null;
    }

    if (isElementHighlight(el)) {
      return el;
    }

    if (!el.parentElement) return null;
    el = el.parentElement;
  }
  return null;
};

export const wrapSelectionInElement = (el: HTMLElement) => {
  const sel = window.getSelection();
  if (sel) {
    const range = sel.getRangeAt(0);
    if (!range) return;
    range.surroundContents(el);
    sel.removeAllRanges();
    sel.addRange(range);
  }
};

export const getHighlightsInSelection = (parentEl?: HTMLElement) => {
  const selection = window.getSelection()!;
  if (!selection) return [];
  const range = selection.getRangeAt(0);

  const el = parentEl ?? range.commonAncestorContainer;
  if (el instanceof HTMLElement) {
    return Array.from(
      el.querySelectorAll("span[data-highlight-active]"),
    ).filter(
      (node) => node instanceof HTMLElement && range.intersectsNode(node),
    ) as HTMLElement[];
  }

  return [];
};

export const highlightElementV3ToV4 = (el: HTMLElement) => {
  el.removeAttribute("class");
  el.setAttribute("data-highlight-active", "false");
  el.setAttribute("data-highlight-animation", "anim-bg");
  el.setAttribute(
    "data-highlight-bg-color",
    "var(--highlight-background-color)",
  );
  el.setAttribute("data-highlight-text-color", "var(--highlight-text-color)");
  el.style.setProperty(
    "--var-highlight-bg-color",
    "var(--highlight-background-color)",
  );
  el.style.setProperty(
    "--var-highlight-text-color",
    "var(--highlight-text-color)",
  );
};
